import { forwardRef } from 'react';
import TextareaAutosize, { type TextareaAutosizeProps } from 'react-textarea-autosize';
import { cn } from '../../lib/cn';

export interface AutoTextareaProps extends Omit<TextareaAutosizeProps, 'minRows' | 'maxRows'> {
  invalid?: boolean;
  minRows?: number;
  maxRows?: number;
}

export const AutoTextarea = forwardRef<HTMLTextAreaElement, AutoTextareaProps>(
  function AutoTextarea({ className, invalid = false, minRows = 2, maxRows = 30, ...rest }, ref) {
    return (
      <TextareaAutosize
        ref={ref}
        minRows={minRows}
        maxRows={maxRows}
        className={cn(
          'w-full px-3 py-2 rounded-xl text-base',
          'bg-tg-section-bg border resize-none',
          'transition-colors duration-150',
          'placeholder:text-tg-hint placeholder:opacity-70',
          'focus:outline-none focus:ring-2 focus:ring-brand/40 focus:border-brand',
          invalid
            ? 'border-destructive/60 focus:ring-destructive/40 focus:border-destructive'
            : 'border-tg-hint/30',
          className,
        )}
        {...rest}
      />
    );
  },
);
